export default __webpack_public_path__ + "static/media/Heavenly Repeater.4cb83433.jpg";